import { AllProductTypes } from '@repo/payments-core';

import {
  MultiStepFormConfigType,
  StepConfigType
} from '../../../types/FieldModelTypes';

import FormFieldWithInitialValue from '../FieldModels/FormFieldWithInitialValue';
import StepConfig from '../StepConfig';
import { UserProfileModel } from '../UserProfileModel';

class MultiStepForm {
  initialStepName: string;
  steps: Array<StepConfig>;
  constructor(
    mulMultiStepFormConfig: MultiStepFormConfigType,
    userProfileDetails: UserProfileModel | null,
    product?: AllProductTypes | null
  ) {
    this.initialStepName = mulMultiStepFormConfig.initial_step_id;
    this.steps = this.getStepsConfig(
      mulMultiStepFormConfig.step_details,
      userProfileDetails,
      product
    );
  }

  getStepsConfig(
    allFormSteps: StepConfigType[],
    userPorfileDetails: UserProfileModel | null,
    product?: AllProductTypes | null
  ) {
    return allFormSteps.map(
      (eachStep) => new StepConfig(eachStep, userPorfileDetails, product)
    );
  }

  get allFormFields() {
    let allFields: Array<FormFieldWithInitialValue> = [];
    this.steps.forEach((eachStep) => {
      allFields = [...allFields, ...eachStep.stepFields];
    });
    return allFields;
  }

  getCreateOrderFormValues = (formSubmitValues: Record<string, any>) => {
    const createOrderFormValues: Record<string, any> = {};
    this.allFormFields?.forEach((eachField) => {
      if (eachField.shouldIncludeInCreateOrder) {
        createOrderFormValues[eachField.field] =
          formSubmitValues[eachField.field];
      }
    });
    return createOrderFormValues;
  };
}

export { MultiStepForm };
export default MultiStepForm;
